import type { ReactNode } from 'react'

export function RailCard({
    title,
    children,
    className = '',
    bodyClassName = '',
}: {
    title: string
    children: ReactNode
    className?: string
    bodyClassName?: string
}) {
    return (
        <section
            className={`border-border bg-card rounded-sm border p-4 shadow-sm ${className}`}>
            <h2 className='text-foreground text-sm font-bold'>{title}</h2>
            <div className={`mt-3 ${bodyClassName}`}>{children}</div>
        </section>
    )
}

export function SummaryRow({
    label,
    children,
}: {
    label: string
    children: ReactNode
}) {
    return (
        <div className='grid grid-cols-[72px_minmax(0,1fr)] gap-3'>
            <dt className='text-muted-foreground'>{label}</dt>
            <dd className='text-foreground min-w-0 text-right font-medium break-keep'>
                {children}
            </dd>
        </div>
    )
}
